import { render } from "./EditMailChannel.vue?vue&type=template&id=d928632c"
import script from "./EditMailChannel.vue?vue&type=script&lang=js"
export * from "./EditMailChannel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__